export default {
    title: 'Ιστορικό αλλαγών',
    trigger: 'Ιστορικό αλλαγών',
    loading: 'Φόρτωση…',
    loadError: 'Δεν ήταν δυνατή η φόρτωση του ιστορικού.',
    subtitle: {
        loading: 'Φόρτωση προηγούμενων εκδόσεων…',
        none: 'Δεν υπάρχουν προηγούμενες εκδόσεις',
        one: '1 προηγούμενη έκδοση',
        many: '{count} προηγούμενες εκδόσεις'
    },
    empty: {
        title: 'Δεν υπάρχουν ακόμη προηγούμενες εκδόσεις',
        body: 'Οι εκδόσεις θα εμφανιστούν εδώ μετά την επόμενη αποθήκευση.'
    },
    emptyContent: '(άδειο)',
    restore: 'Επαναφορά αυτής της έκδοσης',
    restoredFrom: 'Έγινε επαναφορά έκδοσης από {date}.',
    close: 'Κλείσιμο',
    togglePreview: {
        expand: 'Προεπισκόπηση έκδοσης',
        collapse: 'Απόκρυψη προεπισκόπησης'
    }
}
